import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg' : 'bg-[#0a0a0a]'}`} data-id="element-6">
      <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between" data-id="element-7">
        <div className="flex items-center gap-2 min-w-0" data-id="element-8">
          <div className="w-2 h-2 rounded-full bg-[#C8A951] flex-shrink-0" data-id="element-9" />
          <span className="text-white/90 text-sm font-medium truncate" style={{
          fontFamily: "'DM Sans', sans-serif"
        }} data-id="element-10">
            Protocolo Airfryer Premium
          </span>
        </div>

        <button onClick={handleClick} className="flex items-center gap-2 bg-[#2DB742] hover:bg-[#25A038] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] flex-shrink-0 ml-4" aria-label="Quero o Protocolo - Ir para compra" data-id="element-11">
          <ShoppingCartIcon className="w-4 h-4" aria-hidden="true" data-id="element-12" />
          <span className="hidden sm:inline" data-id="element-13">Quero o Protocolo</span>
          <span className="sm:hidden" data-id="element-14">Comprar</span>
        </button>
      </div>
    </header>;
}